module.exports = __webpack_public_path__ + "static/media/dark-hash-left-1.4c704f80.svg";